export default __webpack_public_path__ + "static/media/BlueFish.d7f073f1.png";